import { push } from '@lagunovsky/redux-react-router'
import cx from 'classnames'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import Typography from '../../../../../Typography/Typography'

import hocUser from '../../../../../../services/user/hocUser'

import { getCookie } from 'services/token/helpers'
import './UserAvatar.scss'

// TODO: replace avatar img + css size (ked bude v datach)

const UserAvatar = ({ user, reverse = false, className }) => {
    const intl = useIntl()
    const dispatch = useDispatch()

    let userImage = `images/cinestar/astronaut-avatar.png`
    const imgFromCookie = getCookie('profilePicture')
    if (imgFromCookie) {
        userImage = imgFromCookie
    }
    if (user.profile_picture) {
        userImage = user.profile_picture
    }

    //key is used for rerendering if image is updated (the link is same, key is used
    let key = 0
    if (!!user.imageId) {
        key = user.imageId
    }

    return (
        <div className={cx('user-avatar d-flex align-items-center', reverse && 'flex-row-reverse', className)}>
            <div
                className={cx('d-flex flex-column', reverse ? 'text-start' : 'text-end')}
                role={'button'}
                onClick={() => dispatch(push('/user-profile'))}
            >
                <Typography variant={'label'}>{user?.firstname || 'N/A'}</Typography>
                <Typography variant={'desc'} color={'magentaLighterSecondary'}>
                    {intl.formatMessage({ id: 'global.currency.points' }, { points: user?.loyalty_program?.points })}
                </Typography>
            </div>

            <div className={'user-avatar--img'}>
                <img
                    key={key}
                    src={userImage}
                    alt={'avatar'}
                    role={'button'}
                    onClick={() => dispatch(push('/user-profile'))}
                />
            </div>
        </div>
    )
}

export default hocUser(UserAvatar)
